import * as z from "zod";
import { userFacingError } from "../authorization";
import { assertNotSelfApproval } from "./assertNotSelfApproval";
import { mutator } from "./mutator";

export const approvePushLiveRequestSchema = z.object({ requestId: z.string() });

export const approvePushLiveRequest = mutator({
  schema: approvePushLiveRequestSchema,
  description:
    "Approves a teammate’s push request so they can push their branch live.",
  interactionType: "review",
  resolve: {
    request: { kind: "pushLiveRequest", from: "requestId" },
  },
  permissions: [
    {
      permission: "space:push_live",
      scopeId: ({ args }) => args.request.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args: { request } }) => {
    if (request.commitId !== request.branch.headCommitId)
      throw userFacingError(
        "This branch has changed since the request was sent"
      );
    if (request.approvedByUserId)
      throw userFacingError("This push request is already approved");
    await assertNotSelfApproval(
      tx,
      ctx,
      request.branch.id,
      request.branch.workflowId
    );
    await tx.mutate.pushLiveRequests.update({
      id: request.id,
      approvedByUserId: ctx.userId,
      approvedAt: Date.now(),
    });
  },
});
